import { HTMLAttributes } from 'react';

import styles from './styles.module.css'; // Importar o CSS

interface Props extends HTMLAttributes<HTMLDivElement> {
  width?: string;
  height?: string;
  opacity?: number;
  background?: string;
}

export function Divider({
  width = '100%',
  height = '1px',
  opacity = 0.15,
  background = 'var(--color-white)', // Usando variável CSS padrão
  className,
  ...rest
}: Props): JSX.Element {
  return (
    <div
      className={`${styles.divider} ${className}`} // Adiciona classe para estilos adicionais
      style={{
        width,
        height,
        opacity,
        backgroundColor: background,
      }}
      {...rest}
    />
  );
}
